import React, { FC } from 'react';
import type { Title } from 'src/common/types/api/v4/search/v1/landing';
import type { SimpleQuestion } from 'src/common/types/common/SimpleQuestion';
import Typography from 'src/common/components/Typography';
import DlpLayout from 'src/search/components/DlpLayout';
import LocationFAQs from '../dockyard/LocationFAQs';

import styles from './DlpFAQ.module.scss';

export type DlpFAQProps = {
  faqs: SimpleQuestion[];
  title: Title;
};

const DlpFAQ: FC<DlpFAQProps> = ({ faqs, title }) => (
  <DlpLayout>
    <Typography
      type="h2"
      size="heading-4"
      sizeFromBreakpointM="heading-3"
      weight="semibold"
    >
      {title}
    </Typography>
    <div className={styles.faq}>
      {faqs.map((faq) => (
        <LocationFAQs
          key={faq.question}
          title={faq.question}
        >
          <div
              // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: faq.answer }}
          />
        </LocationFAQs>
      ))}
    </div>
  </DlpLayout>
);

export default DlpFAQ;
